<img
  *ngIf="text.length"
  class="warning-icon"
  src="{{ iconPath }}"
  [matTooltip]="text"
  matTooltipPosition="above"
  matTooltipClass="orms-tooltip orms-cr-tooltip"
  alt="{{ 'imgAlt.warning' | translate }}"
/>
